import React from 'react';
import { IProduct } from 'base/interfaces/product';
import Link from '@base/lib/ThemeLink';
import transLink from 'base/utils/transLink';
import { IElementTarget } from 'base/interfaces/common';
import cn from 'classnames';

export type ListProductNameProps = {
    product: IProduct;
    canJump?: boolean;
    aTarget?: IElementTarget;
    className?: string;
    onClick?: () => void;
    'data-t-tar'?: string;
    'data-t-pos'?: string;
};

const ListProductName = React.forwardRef<HTMLDivElement, ListProductNameProps>((props, ref) => {
    const {
        aTarget = '_self',
        product: {
            link = '',
            name = '',
        },
        canJump = true,
        className,
        onClick,
        'data-t-tar': dataTrackTarget,
        'data-t-pos': dataTrackPosition,
    } = props;

    return (
        <div
            ref={ref}
            className="name text-wrap"
            data-t-tar={dataTrackTarget}
            data-t-pos={dataTrackPosition}
        >
            {canJump ? (
                <Link href={transLink(link)}>
                    <a target={aTarget} className={cn(className, 'js-track-link')} onClick={onClick}>{name}</a>
                </Link>
            ) : (
                <p className={className} onClick={onClick}>{name}</p>
            )}
        </div>
    )
});


export default ListProductName;